import Services from '../Service'

class AdminUserService extends Services {
  constructor() {
    super()
    this.resource = 'admin/users'
  }

  async getUsers(params) {
    return await this.getAPI(this.resource, params)
  }

  async getUser(id) {
    return await this.getAPI(`${this.resource}/${id}`)
  }

  async createUser(payload) {
    return await this.postAPI(this.resource, payload)
  }

  async updateUser(payload, id) {
    return await this._http.put(`${this.resource}/${id}`, payload)
  }

  async deleteUser(id) {
    try {
      const { data } = await this._http.delete(`${this.resource}/${id}`)
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async getOptions() {
    return await this.getAPI(`${this.resource}/options`)
  }

  // Valores distintos de um atributo da ITENS (fabricantes, grupos, marcas,
  // listaOfertas), pesquisáveis. Substitui o carregamento das quatro listas
  // inteiras que `getOptions` fazia.
  async getOptionAtributos(params) {
    return await this.getAPI(`${this.resource}/options/atributos`, params)
  }
}

export default new AdminUserService()
